// ============================================================
// CONTENUTI DEL SITO — testi ed elenchi facilmente modificabili.
// ============================================================

export const PERCORSI = [
  {
    numero: "01",
    slug: "/diplomi",
    titolo: "Diplomi",
    descrizione:
      "Percorsi per il conseguimento del diploma, con orientamento personalizzato per individuare la strada più adatta al tuo punto di partenza.",
    icon: "GraduationCap",
    image: "/assets/diplomi.jpg",
  },
  {
    numero: "02",
    slug: "/lauree",
    titolo: "Lauree",
    descrizione:
      "Percorsi universitari attraverso le collaborazioni con eCampus e Link, con accompagnamento dello studente durante tutto il percorso.",
    icon: "LibraryBig",
    image: "/assets/lauree.jpg",
  },
  {
    numero: "03",
    slug: "/formazione-professionale",
    titolo: "Corsi di formazione professionale",
    descrizione:
      "Corsi pensati per sviluppare competenze spendibili nel mondo del lavoro, con un percorso costruito sulle tue esigenze.",
    icon: "BriefcaseBusiness",
    image: "/assets/formazione.jpg",
  },
  {
    numero: "04",
    slug: "/certificazioni",
    titolo: "Certificazioni linguistiche e informatiche",
    descrizione:
      "Percorsi per certificare le competenze linguistiche e digitali, utili per lo studio, il lavoro e la crescita professionale.",
    icon: "Languages",
    image: "/assets/certificazioni.jpg",
  },
];

export const MANIFESTO = [
  {
    num: "01",
    titolo: "Orientamento personalizzato",
    testo:
      "Ogni percorso inizia dall'ascolto: obiettivi, tempo a disposizione e punto di partenza. Da qui costruiamo insieme la strada più adatta a te.",
  },
  {
    num: "02",
    titolo: "Accompagnamento costante",
    testo:
      "Lo studente viene seguito durante tutto il percorso, dal primo colloquio fino al raggiungimento del titolo o della certificazione.",
  },
  {
    num: "03",
    titolo: "Chiarezza in ogni passaggio",
    testo:
      "Informazioni trasparenti su percorsi e requisiti, senza promesse impossibili: solo un piano concreto e un punto di riferimento affidabile.",
  },
  {
    num: "04",
    titolo: "Un unico punto di riferimento",
    testo:
      "Diplomi, lauree, formazione professionale e certificazioni: Forma Futuro ti aiuta a orientarti tra le opportunità e semplifica ogni passaggio.",
  },
];

export const LAUREE_PARTNERS = [
  {
    nome: "eCampus",
    logo: "/assets/logo-ecampus.png",
    descrizione:
      "Percorsi universitari in collaborazione con eCampus, con la flessibilità della formazione a distanza.",
  },
  {
    nome: "Link",
    logo: "/assets/logo-link.png",
    descrizione:
      "Percorsi universitari in collaborazione con Link, per un'offerta formativa ampia e articolata.",
  },
];

// Elenco dei corsi di formazione professionale.
// Per aggiungere un corso, copia un blocco e modifica i campi.
export const CORSI_FORMAZIONE = [
  {
    titolo: "OSA — Operatore Socio Assistenziale",
    intro:
      "Percorso formativo della durata di 300 ore, con svolgimento completamente online.",
    dettagli: [
      { label: "Accesso", value: "Licenza media, età minima 16 anni" },
      { label: "Durata", value: "300 ore" },
      { label: "Modalità", value: "Online" },
      { label: "Accreditamento", value: "Regione Campania" },
      {
        label: "Validità",
        value:
          "1 punto per l'aggiornamento della graduatoria ATA – Collaboratore Scolastico",
      },
    ],
    prezzo: "€ 600",
  },
  {
    titolo: "OSS — Operatore Socio Sanitario",
    intro:
      "Percorso formativo della durata di 450 ore, con svolgimento in presenza e tirocinio in Regione Campania.",
    dettagli: [
      { label: "Accesso", value: "Licenza media, età minima 16 anni" },
      { label: "Durata", value: "450 ore" },
      { label: "Modalità", value: "In presenza" },
      { label: "Tirocinio", value: "Svolto in Regione Campania" },
      { label: "Accreditamento", value: "Regione Campania" },
      {
        label: "Validità",
        value:
          "1 punto per l'aggiornamento delle graduatorie ATA – Collaboratore Scolastico",
      },
    ],
    prezzo: "€ 1.499",
  },
  {
    titolo: "ASACOM — Assistente all'Autonomia e alla Comunicazione",
    intro:
      "Percorso formativo della durata di 500 ore, con svolgimento online.",
    dettagli: [
      { label: "Durata", value: "500 ore" },
      { label: "Modalità", value: "Online" },
      { label: "Accreditamento", value: "Regione Campania" },
      { label: "Validità", value: "1 punto ATA" },
    ],
    prezzo: "€ 900",
  },
  {
    titolo: "OAC — Operatore dell'Accoglienza",
    intro:
      "Percorso formativo della durata di 300 ore, con svolgimento online.",
    dettagli: [
      { label: "Durata", value: "300 ore" },
      { label: "Modalità", value: "Online" },
      { label: "Accreditamento", value: "Regione Campania" },
      { label: "Validità", value: "Aggiornamento ATA" },
    ],
    prezzo: "€ 600",
  },
  {
    titolo: "OPI — Operatore dell'Infanzia",
    intro:
      "Percorso formativo della durata di 300 ore, con svolgimento online.",
    dettagli: [
      { label: "Durata", value: "300 ore" },
      { label: "Modalità", value: "Online" },
      { label: "Accreditamento", value: "Regione Campania" },
    ],
    prezzo: "€ 600",
  },
];

export const MARQUEE_ITEMS = [
  "Orientamento personalizzato",
  "Diplomi",
  "Lauree eCampus e Link",
  "Formazione professionale",
  "Certificazioni linguistiche",
  "Certificazioni informatiche",
  "Assistenza allo studente",
];
